export async function fetchIpAddress(): Promise<any | null> {
    const response = await fetch(`api/webchat/t/ip`);
    if (!response.ok) {
      return '0.0.0.0';
    }
    return response.json();
}